import { isFalsy } from 'utility-types';
import fetchRequest from '@/api/api';
import type { BaseApiResponse, BaseApiResult } from '@/interfaces/service/api.interface';
import type { LoginDto, OtpDto, SignUpDto, SignUpOtpDto, Token } from '@/interfaces/service/auth.interface';
import { ROUTES, USER_SIGNUP_URL } from '@/constants/path.constants';
import { checkHttpRequestResult } from '@/utils/api.util';
import { clearToken } from '@/utils/auth.util';
import { getToken, setToken } from '@/utils/auth.util';
import { SEND_OPT_URL, SEND_OPT_URL_SIGN_UP, TOKEN_REFRESH_URL, USER_LOGIN_URL } from '@/libs/constants/url';
import { setRole } from '@/libs/utils/authn';

export const signUp = async (userData: SignUpDto): Promise<BaseApiResult<Token> | null> => {
  try {
    const res: BaseApiResponse<Token> = await fetchRequest({
      endpoint: USER_SIGNUP_URL,
      method: 'POST',
      body: userData
    });
    return checkHttpRequestResult(res);
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const login = async (loginData: LoginDto): Promise<BaseApiResult<Token> | null> => {
  try {
    const res: BaseApiResponse<Token> = await fetchRequest({
      endpoint: USER_LOGIN_URL,
      method: 'POST',
      body: loginData
    });
    return checkHttpRequestResult(res);
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const sendOtp = async (requestOtpParams: OtpDto | SignUpOtpDto): Promise<BaseApiResult<{ maskedPhone: string }> | void> => {
  try {
    const res: BaseApiResponse<{ maskedPhone: string }> = await fetchRequest({
      endpoint: SEND_OPT_URL_SIGN_UP,
      method: 'POST',
      body: requestOtpParams
    });
    console.log('check res', res);
    return checkHttpRequestResult(res);
  } catch (error) {
    console.log({ error });
  }
};

export const refreshAccessToken = async (): Promise<Token | void> => {
  const originalToken: Token | null = getToken();

  if (originalToken !== null) {
    try {
      const res: BaseApiResponse<Token> = await fetchRequest({
        endpoint: TOKEN_REFRESH_URL,
        method: 'POST',
        headers: [['RefreshToken', originalToken.refreshToken]]
      });

      const { isSuccess, data, result } = checkHttpRequestResult(res);
      const refreshedToken = data ?? result;

      if (isSuccess && !isFalsy(refreshedToken)) {
        clearToken();
        setToken(refreshedToken);
        setRole();
        return refreshedToken;
      } else if (typeof window !== 'undefined') {
        window.location.replace(ROUTES.getRedirectMiddleware({ type: 'TOKEN_EXPIRED' }));
      }
    } catch (error) {
      console.error('토큰 갱신 중 오류 발생:', error);
    }
  }
};
